import { useState } from 'react';
import { useModalState } from '../../../hooks/useModalState';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { StatusType } from '../../orders/order.types';
import {
  BypassOrderOnApprovalSettingName,
  handleChangeAndBlurParams,
} from '../types/generalSettingsPage.types';

interface UseBypassOrderOnApprovalSettingModalParams {
  handleChangeAndBlur: (params: handleChangeAndBlurParams) => Promise<void>;
}

export const useBypassOrderOnApprovalAlertModal = ({
  handleChangeAndBlur,
}: UseBypassOrderOnApprovalSettingModalParams) => {
  const { integrations } = useApplicationContext();

  const { isOpen, openModal, closeModal } = useModalState();

  const [pendingSettingName, setPendingSettingName] =
    useState<BypassOrderOnApprovalSettingName | null>(null);

  const handleChangeBypassOrderOnApproval = async (
    name: BypassOrderOnApprovalSettingName,
    value: boolean,
  ) => {
    await handleChangeAndBlur({ value, name });

    closeModal();
  };

  const handleBypassOrderOnApprovalAlert = (
    name: BypassOrderOnApprovalSettingName,
    checked: boolean,
  ) => {
    if (!checked) {
      return handleChangeBypassOrderOnApproval(name, checked);
    }

    const hasIntegrationOnApproval = integrations?.some(
      (item) => item.active && item.integrationTrigger === StatusType.ON_APPROVAL,
    );

    if (hasIntegrationOnApproval) {
      setPendingSettingName(name);
      openModal();
    } else {
      handleChangeBypassOrderOnApproval(name, checked);
    }
  };

  const handleAcceptBypassOrderOnApproval = () => {
    if (pendingSettingName) {
      handleChangeBypassOrderOnApproval(pendingSettingName, true);
    }
  };

  return {
    isOpen,
    closeModal,
    handleBypassOrderOnApprovalAlert,
    handleAcceptBypassOrderOnApproval,
  };
};
